export default __webpack_public_path__ + "static/media/pulmonary.ca4cbabd.jpg";